import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TabsInnerWrapComponent } from '../../components/tabs-inner-wrap/tabs-inner-wrap.component';
import { SimulationInformationComponent } from './simulation-information/simulation-information.component';
import { PersonaInformationComponent } from './persona-information/persona-information.component';
import { SimulationDetailsInformationComponent } from './simulation-details-information/simulation-details-information.component';

@Component({
  selector: 'tab-general-content',
  standalone: true,
  templateUrl: './general-content.component.html',
  styleUrls: ['./general-content.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    TabsInnerWrapComponent,
    SimulationInformationComponent,
    PersonaInformationComponent,
    SimulationDetailsInformationComponent,
  ],
})

export class GeneralContentComponent {}
